import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-patient-edit',
  templateUrl: './patient-edit.component.html',
  styleUrls: ['./patient-edit.component.scss']
})
export class PatientEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
